module.exports = ['$scope', '$timeout', function($scope, $timeout) {
  let emitOverlayHidden = true; // Allow switching off event emitting for detailsHidden

  this.horizontalTicks = 5;

  this.hideOverlay = () => {
    if (emitOverlayHidden) {
      $scope.$emit('overlayHidden');
    }

    emitOverlayHidden = true;
  };

  this.getDataPoint = (x,y) => {
    if (!this.results) { return; }
    const point = _.binarySearch(this.results, data => x - data.date);

    if (!point) { return; }
    this.dataPoint = point;
    $scope.$emit('chartClicked', this.dataPoint);

    return [x, point.total];
  };

  $scope.$on('detailsHidden', e => {
    emitOverlayHidden = false;
    $timeout(() => angular.element('#overlayAxis').click());
  });

  this.getDataPoint(0,0); // Strangely needed to initialize

  const weekFormat = [["%a", () => true]];
  const monthFormat = [
    ["%b %d", d => d.getDate() !== 1],
    ["%b", d => d.getMonth()],
    ["%Y", () => true]
  ];

  this.timeFormat = function() {
    if ((this.results == null) || !(this.results.length > 1)) { return; }

    const start = this.results[0], end = this.results[this.results.length - 1];
    const timespan = moment(end.date).diff(start.date);

    // If less than a week
    if (timespan <= (moment.duration(1, 'w') + 1)) {
      return weekFormat;
    } else {
      return monthFormat;
    }
  };

  return this;
}];
